/**
 * @file Board-control state helpers for active options and menu restoration.
 */

import {
  getBoardViewSettings,
  getEffectiveViewLayout,
} from "../../app/state/state.js";

let openMenuState = null;

/**
 * Returns the currently active board/table grouping key.
 * @param {string} viewKey - Board view key.
 * @returns {string} Active grouping key.
 */
export function getActiveGroupBy(viewKey) {
  const settings = getBoardViewSettings(viewKey);
  if (!settings) {return "status";}
  return getEffectiveViewLayout(viewKey) === "table" ?
    settings.tableGroupBy :
    settings.boardGroupBy;
}

/**
 * Returns the currently active date grouping mode.
 * @param {string} viewKey - Board view key.
 * @returns {string} Active date grouping mode.
 */
export function getActiveDateGroupingMode(viewKey) {
  const settings = getBoardViewSettings(viewKey);
  if (!settings) {return "weekly";}
  return getEffectiveViewLayout(viewKey) === "table" ?
    settings.tableDateGroupingMode :
    settings.boardDateGroupingMode;
}

/**
 * Reads the open board-control menu state.
 * @returns {object|null} Open menu state.
 */
export function getOpenMenuState() {
  return openMenuState;
}

/**
 * Replaces the open board-control menu state.
 * @param {object|null} nextState - Next menu state.
 * @returns {void}
 */
export function setOpenMenuState(nextState) {
  openMenuState = nextState;
}

/**
 * Clears the open board-control menu state.
 * @returns {void}
 */
export function clearOpenMenuState() {
  openMenuState = null;
}

/**
 * Stores the filter menu detail/category state.
 * @param {string} viewKey - Board view key.
 * @param {string|null} [categoryKey] - Active filter category key.
 * @returns {void}
 */
export function setFilterMenuState(viewKey, categoryKey = null) {
  openMenuState = { viewKey, menuId: "filter", categoryKey };
}

/**
 * Stores the group menu root/detail page state.
 * @param {string} viewKey - Board view key.
 * @param {string|null} [pageKey] - Active group menu page key.
 * @returns {void}
 */
export function setGroupMenuState(viewKey, pageKey = null) {
  openMenuState = { viewKey, menuId: "group", pageKey };
}
